<template>
  <div id="app">
    <div class="sidebar">
      <div class="navbar">
        <ul>
          <li @click="goTo('nav-kv')" :class="{active: navActive === 'nav-kv'}">首页</li>
          <li @click="goTo('nav-shopping')" :class="{active: navActive === 'nav-shopping'}">购买详情</li>
          <li @click="goTo('nav-staff')" :class="{active: navActive === 'nav-staff'}">专辑介绍&Staff</li>
          <li @click="goTo('nav-bvi')" :class="{active: navActive === 'nav-bvi'}">新公布曲目</li>
          <li @click="goTo('nav-thanks')" :class="{active: navActive === 'nav-thanks'}">特别鸣谢</li>
        </ul>
      </div>
      <div class="sidebar-share mt-3">
        <div class="share-title">分享到</div>
        <div ref="share"></div>
      </div>
    </div>
    <div class="page">
      <!--首屏-->
      <div id="nav-kv">
        <div class="kv" :style="`background-image: url(${require('@/assets/images/chaomeng_bg.jpg')})`">
          <div class="logo" :style="`background: url(${require('@/assets/images/logo.png')}) center / contain no-repeat`"></div>
        </div>
      </div>
      <!--专辑购买广告-->
      <div id="nav-shopping">
        <div class="shopping mt-4">
          <div class="page-container container">
            <div class="panel-chaomeng">
              <div class="row">
                <div class="col-sm-6 order-sm-1 order-2">
                  <hooper class="hooper" :infiniteScroll="true" :autoPlay="false" :playSpeed="2000">
                    <slide><a href="https://www.bilibili.com/read/cv3625903" target="_blank" class="chaomeng-banner" :style="`background-image: url(${require('@/assets/images/banner_1.jpg')})`"></a></slide>
                    <hooper-navigation slot="hooper-addons"></hooper-navigation>
                    <hooper-pagination slot="hooper-addons"></hooper-pagination>
                  </hooper>
                </div>
                <div class="col-sm-6 order-sm-1">
                  <div class="row">
                    <div class="col-6">
                      <a href="https://bw.bilibili.com/2019/index.html#/shanghai/" target="_blank" class="video-btn btn"><div class="icon" :style="`background-image: url(${require('@/assets/images/btn_icon_bili.png')})`"><span>线下发布会<br><small>门票购买</small></span></div></a>
                    </div>
                    <div class="col-6">
                      <a href="http://chaodianwenhua.tmall.com/p/rd437469.htm" target="_blank" class="buy-btn btn"><div class="icon" :style="`background-image: url(${require('@/assets/images/btn_icon_shop.png')})`"><span>专辑购买</span></div></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-album mt-5">
              <div class="row">
                <div class="col-sm-6 mb-sm-0 mb-4">
                  <a class="album-gold" data-aos="fade-right" :style="`background-image: url(${require('@/assets/images/album_gold.jpg')})`" href="https://detail.tmall.com/item.htm?spm=a212k0.12153887.0.0.61c0687do4DotE&id=600691557167" target="_blank">
                    <div class="album-shop">
                      <h2 class="mb-0 text-dark">典藏版</h2>
                      <h4 class="mb-1 font-weight-light text-dark"></h4>
                      <h2 class="mb-0 text-primary"></h2>
                      <h5 class="font-weight-light"></h5>
                    </div>
                    <div class="album-shop-content">
                      <h2 class="mb-0 text-right">典藏版</h2>
                      <p class="mb-0">内含:</p>
                      <ul>
                        <li>音乐专辑CD一张</li>
                        <li>精美UP主纪念闪卡套装一套（40张/套）</li>
                        <li>精美UP主纪念烫金卡9张</li>
                        <li>主题镭射透明PVC挂绳一只</li>
                        <li>歌曲多彩纪念徽章套装（6枚/套）</li>
                        <li>定制纪念皮质笔记本+精致黄铜笔套装</li>
                      </ul>
                    </div>
                  </a>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col-6">
                      <a class="album-var" data-aos="fade-left" :style="`background-image: url(${require('@/assets/images/album_pro.jpg')})`" href="https://detail.tmall.com/item.htm?spm=a212k0.12153887.0.0.61c0687do4DotE&id=600456648865" target="_blank">
                        <div class="album-shop">
                          <h2 class="mb-0 text-dark">珍藏版</h2>
                          <h4 class="mb-1 font-weight-light text-dark"></h4>
                          <h2 class="mb-0 text-primary"></h2>
                          <h5 class="font-weight-light"></h5>
                        </div>
                        <div class="album-shop-content">
                          <h2 class="mb-0 text-right">珍藏版</h2>
                          <p class="mb-0">内含:</p>
                          <ul>
                            <li>音乐专辑CD一张</li>
                            <li>精美UP主纪念闪卡套装一套（40张/套）</li>
                            <li>精美UP主纪念烫金卡1张</li>
                            <li>主题镭射透明PVC挂绳一只</li>
                          </ul>
                        </div>
                      </a>
                    </div>
                    <div class="col-6">
                      <a class="album-var" data-aos="fade-left" :style="`background-image: url(${require('@/assets/images/album_std.jpg')})`" href="https://detail.tmall.com/item.htm?spm=a212k0.12153887.0.0.61c0687do4DotE&id=600690457701" target="_blank">
                        <div class="album-shop">
                          <h2 class="mb-0 text-dark">收藏版</h2>
                          <h4 class="mb-1 font-weight-light text-dark"></h4>
                          <h2 class="mb-0 text-primary"></h2>
                          <h5 class="font-weight-light"></h5>
                        </div>
                        <div class="album-shop-content">
                          <h2 class="mb-0 text-right">收藏版</h2>
                          <p class="mb-0">内含:</p>
                          <ul>
                            <li>音乐专辑CD一张</li>
                          </ul>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="nav-staff">
        <div class="staff p-md-5 mt-5" :style="`background: url(${require('@/assets/images/bg_1.jpg')}) center / contain no-repeat`">
          <div class="page-container container">
            <div class="page-title mb-3">
              <h2 data-aos="fade-left">主创</h2>
              <span class="sub-title d-none d-md-inline-block" data-aos="fade-right">UP主</span>
            </div>
            <photo-wall height="75vw" data-aos="fade-up" :photos="waterPhotos" :rowNum="5" :swap="0"></photo-wall>
          </div>
        </div>
      </div>
      <div class="content p-md-5 mt-5">
        <div class="page-container container">
          <div class="page-title mb-4">
            <h2 data-aos="fade-left">专辑</h2>
            <span class="sub-title d-none d-md-inline-block" data-aos="fade-right">简介</span>
          </div>
          <div class="panel-about">
            <div class="row">
              <div class="col-md-5 text-center">
                <img class="img-fluid mt-4" data-aos="fade-up" src="./assets/images/cover.png" />
              </div>
              <div class="col-md-7">
                <div class="panel-about-body">
                  <div class="about-quo quo-o" :style="`background: url(${require('@/assets/images/quo_o.png')}) center / contain no-repeat`"></div>
                  <div class="about-text" data-aos="zoom-in">
                    <p>《超梦计划》是由超电文化和B站UP主们共同完成的原创内容企划。取超电的“超”及梦想的“梦”字，意为超电文化携手旗下UP主们一起向梦想出发启航，并不止步于实现梦想，更要去超越梦想。</p>
                    <p>本次企划同名音乐专辑首次尝试联动50余位在B站各领域有出色表现的知名UP主共同创作和演唱，呈现出一场“国风与电子混搭”、“流行与传统碰撞”的视听盛宴。</p>
                  </div>
                  <div class="about-quo quo-c" :style="`background: url(${require('@/assets/images/quo_c.png')}) center / contain no-repeat`"></div>
                </div>
              </div>
            </div>
          </div>

          <div id="nav-bvi">
            <div class="page-title mb-4 mt-6">
              <h2 data-aos="fade-left">已发布</h2>
              <span class="sub-title d-none d-md-inline-block" data-aos="fade-right">歌曲</span>
            </div>
            <collapse height="63.06vh" data-aos="fade-up" style="max-height: 580px">
              <collapse-item class="bvi-1" title="千里邀月">
                <iframe src="//www.bilibili.com/blackboard/newplayer.html?aid=37404066&cid=65745176&page=1&autoplay=0" width="100%" style="max-width: 720px" height="100%" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
              </collapse-item>
              <collapse-item class="bvi-2" title="对你青睐">
                <iframe src="//www.bilibili.com/blackboard/newplayer.html?aid=46257482&cid=81045697&page=1&autoplay=0" width="100%" style="max-width: 720px" height="100%" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
              </collapse-item>
              <collapse-item class="bvi-3" title="六月与萤火虫">
                <iframe src="//www.bilibili.com/blackboard/newplayer.html?aid=56204429&cid=98238109&page=1&autoplay=0" width="100%" style="max-width: 720px" height="100%" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
              </collapse-item>
              <collapse-item class="bvi-4" title="舌战江湖侠骨篇">
                <iframe src="//www.bilibili.com/blackboard/newplayer.html?aid=60616253&cid=105505510&page=1&autoplay=0" width="100%" style="max-width: 720px" height="100%" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
              </collapse-item>
              <collapse-item title="未完待续" disabled></collapse-item>
            </collapse>
          </div>
        </div>
      </div>
      <div id="nav-thanks">
        <div class="thanks mt-6">
          <div class="page-container container">
            <div class="thanks-container">
              <div class="text-center mb-4">
                <h3>独家视频播放平台</h3>
                <img src="./assets/images/tks_bilibili.png" class="img-fluid" data-aos="zoom-in" />
              </div>
              <div class="text-center mb-4">
                <h3>独家战略合作伙伴</h3>
                <img src="./assets/images/tks_music.png" class="img-fluid" data-aos="zoom-in" />
              </div>
              <div class="text-center">
                <h3>特别鸣谢</h3>
                <div class="px-5">
                  <div class="row">
                    <div class="col"><img src="./assets/images/tks_qsp.png" class="img-fluid" data-aos="zoom-in" width="180" /></div>
                    <div class="col"><img src="./assets/images/tks_xg.png" class="img-fluid" data-aos="zoom-in" width="180" /></div>
                    <div class="col"><img src="./assets/images/tks_hk.png" class="img-fluid" data-aos="zoom-in" width="180"  /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="index-video" ref="indexVideo" @click="closeVideo">
      <div class="index-video-mask"></div>
      <div class="index-video-content">
        <div class="index-video-inner">
          <div class="index-video-player-box">
            <div class="index-video-player-wrap" style="height: 100%;">
              <iframe class="index-video-player-iframe" src="//www.bilibili.com/blackboard/newplayer.html?aid=67465607&cid=116975563&autoplay=0" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"></iframe>
            </div>
            <p class="index-video-close"><b id="index-video-close-text" style="opacity: 1;" @click="closeVideo">关闭</b></p>
          </div>
        </div>
      </div>
    </div>
    <div class="page-container container">
      <bili-comment :oid="15195" :pageType="4"></bili-comment>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Slider from './components/Slider'
import {Hooper, Slide, Navigation as HooperNavigation, Pagination as HooperPagination} from 'hooper'
import 'hooper/dist/hooper.css'
import WaterFallSlide from './components/WaterFallSlide'
import Collapse from './components/Collapse'
import CollapseItem from './components/CollapseItem'
import PhotoWall from './components/PhotoWall'
import biliShare from '@bilibili/share-pc';
Vue.use(biliShare)
import BiliComment from '@bilibili/comment-h5/dist/Comment'

import AOS from 'aos'
import 'aos/dist/aos.css'
Vue.use(AOS)

let vueSmoothScroll = require('vue-smoothscroll')
Vue.use(vueSmoothScroll)

const shareConfig = {
  title: '“超梦计划”首张UP主音乐专辑预售正式开启',
  desc: '这些UP主竟然一起出了一张专辑？快来看看有你喜欢的UP主吗~#超梦计划#',
  link: window.location.href,
  pics:'//i0.hdslb.com/bfs/activity-plat/activity14623/images/share.jpg',
  show: ['bili', 'weibo', 'qzone', 'baidu_tieba', 'wechat'],   //选填项，单独显示选择的分享途径
  biz_type: 3,      // 选填项，显示动态分享功能，请按需填写如下字段参数
}

export default {
  name: 'app',
  data() {
    return {
      waterPhotos: [
        [
          {title: '茶理理', image: 'images/up/chalili.jpg'}
        ],
        [
          {title: '肥皂菌', image: 'images/up/feizaojun.jpg'}
        ],
        [
          {title: '果哝双子', image: 'images/up/guonongshuangzi.jpg'}
        ],
        [
          {title: 'hanser', image: 'images/up/hanser.jpg'}
        ],
        [
          {title: '泠鸢yousa', image: 'images/up/yousa.jpg'}
        ],
        [
          {title: '刘夏俊Jun', image: 'images/up/liuxiajun.jpg'}
        ],
        [
          {title: '没错我就是惠惠', image: 'images/up/huihui.jpg'}
        ],
        [
          {title: '萌爱moi', image: 'images/up/moi.jpg'}
        ],
        [
          {title: '漠☆漠', image: 'images/up/momo.jpg'}
        ],
        [
          {title: '脐带老妖', image: 'images/up/qidailaoyao.jpg'}
        ],
        [
          {title: '三无Marblue', image: 'images/up/marblue.jpg'}
        ],
        [
          {title: '兔总裁', image: 'images/up/tuzongcai.jpg'}
        ],
        [
          {title: '逍遥散人', image: 'images/up/sanren.jpg'}
        ],
        [
          {title: '易言', image: 'images/up/yiyan.jpg'}
        ],
        [
          {title: '早木旋子', image: 'images/up/zaomuxuanzi.jpg'}
        ],
        [
          {title: 'cv王胖子', image: 'images/up/wangpangzi.jpg'}
        ],
        [
          {title: 'Tocci椭奇', image: 'images/up/tocci.jpg'}
        ],
        [
          {title: 'YUKIri', image: 'images/up/yukiri.jpg'}
        ],
        [
          {title: 'Mr.mo', image: 'images/up/mrmo.jpg'}
        ],
        [
          {title: '敖厂长', image: 'images/up2/aochangzhang.jpg'}
        ],
        [
          {title: '白止', image: 'images/up2/baizhi.jpg'}
        ],
        [
          {title: '吃素的狮子', image: 'images/up2/chisudeshizi.jpg'}
        ],
        [
          {title: '逗川kshadow', image: 'images/up2/douchuan.jpg'}
        ],
        [
          {title: '尕丶天堂', image: 'images/up2/xiaotiantang.jpg'}
        ],
        [
          {title: '还有一天就放假了', image: 'images/up2/fangjia.jpg'}
        ],
        [
          {title: '黑桐谷歌', image: 'images/up2/heitongguge.jpg'}
        ],
        [
          {title: '敬汉卿', image: 'images/up2/jinghaiqin.jpg'}
        ],
        [
          {title: '靠脸吃饭的徐大王', image: 'images/up2/xudawang.jpg'}
        ],
        [
          {title: '凉风Kaze', image: 'images/up2/kaze.jpg'}
        ],
        [
          {title: '神奇陆夫人', image: 'images/up2/lufuren.jpg'}
        ],
        [
          {title: '视角姬', image: 'images/up2/shijiaoji.jpg'}
        ],
        [
          {title: '夙胤言生', image: 'images/up2/yansheng.jpg'}
        ],
        [
          {title: '丸子', image: 'images/up2/wanzi.jpg'}
        ],
        [
          {title: '小可儿', image: 'images/up2/xiaokeer.jpg'}
        ],
        [
          {title: '徐大sao', image: 'images/up2/xuda.jpg'}
        ],
        [
          {title: '中国BOY', image: 'images/up2/chinaboy.jpg'}
        ],
        [
          {title: '祖娅纳惜', image: 'images/up2/zuyanaxi.jpg'}
        ],
        [
          {title: 'A路人', image: 'images/up2/aluren.jpg'}
        ],
        [
          {title: 'EdmundDZhang', image: 'images/up2/edmunddzhang.jpg'}
        ],
        [
          {title: 'KBShinya', image: 'images/up2/kbshinya.jpg'}
        ],
      ],
      navActive: 'nav-kv',
      scroll: ''
    }
  },
  watch: {
    scroll() {
      if(this.scroll >= document.getElementById('nav-kv').offsetTop && this.scroll < document.getElementById('nav-shopping').offsetTop - 1) {
        this.navActive = 'nav-kv'
      }else if(this.scroll >= document.getElementById('nav-shopping').offsetTop - 1 && this.scroll < document.getElementById('nav-staff').offsetTop - 1) {
        this.navActive = 'nav-shopping'
      }else if(this.scroll >= document.getElementById('nav-staff').offsetTop - 1 && this.scroll < document.getElementById('nav-bvi').offsetTop - 1) {
        this.navActive = 'nav-staff'
      } else if(this.scroll >= document.getElementById('nav-bvi').offsetTop - 1 && this.scroll < document.getElementById('nav-thanks').offsetTop - 1) {
        this.navActive = 'nav-bvi'
      }else if(this.scroll >= document.getElementById('nav-thanks').offsetTop - 1) {
        this.navActive = 'nav-thanks'
      }

      let scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
      //变量windowHeight是可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
      // 判断是否滚到底部
      if(scrollTop + windowHeight === scrollHeight){
        this.navActive = 'nav-thanks'
      }
    }
  },
  components: {
    Slider,
    WaterFallSlide,
    Collapse,
    CollapseItem,
    PhotoWall,
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
    BiliComment
  },
  methods: {
    goTo(ele) {
      let vm = this
      this.$SmoothScroll(document.getElementById(ele), 500, function () {
      })
    },
    getScroll() {
      this.scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    },
    handleShare() {
      let vm = this

    },
    async closeVideo () {
      //动画
      console.log('11')
      this.$refs.indexVideo.style.transition = '0.2s'
      this.$refs.indexVideo.style.opacity = '0'
      await this.timeout(200)
      this.$refs.indexVideo.innerHTML = ''
      this.$refs.indexVideo.style.display = 'none'

    },
    //定时器
    timeout(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  mounted() {
    window.addEventListener('scroll',this.getScroll)
    AOS.init({
      once: true
    })

    biliSharePC.share(shareConfig, this.$refs.share, (type) => {console.log(type);});
  }
}
</script>

<style lang="scss">
//分享组件
#biliSharePc .share {
  font-size: 16px;
  width: auto;
  display: flex;
  justify-content: space-around;

  .icon {
    background-image: none;
    width: auto;
    height: auto;
    font-family: "iconfont" !important;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: inherit;
    transition: all 0.2s ease-in-out;

    &:hover {
      color: #FFDD00;
    }
  }

  .icon_bili {
    &:before {
      content: "\e600";
    }
  }
  .icon_weibo {
    &:before {
      content: "\e831";
    }
  }
  .icon_qzone {
    &:before {
      content: "\e6a4";
    }
  }
  .icon_baidu_tieba {
    &:before {
      content: "\e606";
    }
  }
  .icon_wechat {
    &:before {
      content: "\e625";
    }
  }

  .weixin-hover {
    right: 0;
    top: 40px;
    margin-right: -10px;
  }
  .icon-hover .share-weixin-qr {
    position: static;
  }
}

</style>
